import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { GetCatalogGeoData, GetCatalogInfo, GetSelectCatalog, SetSelectCatalog } from '@shared/state/catalog/shared-catalog.action';
import { SetChosenCatalogOnMap } from 'app/modules/main/store/main-page.action';
import { MainPageState } from 'app/modules/main/store/main-page.state';
import { Observable, Subject } from 'rxjs';
import { GetRecommendationCatalogItemsForUser } from '@shared/state/shared/shared.action';
import { takeUntil } from 'rxjs/operators';
import { TakeUntilDestroy } from '@utils/auto-unsubscribe';
import { ActivatedRoute, Router } from '@angular/router';
import { setLocationQueryParams } from '@utils/other-utils';
import { Location } from '@angular/common';
import { CustomIcons } from '@shared/models/custom-icons';
import { cloneDeep } from 'lodash';
import { MainPageService } from '../../services/main-page.service';
import { CarouselData } from '../../models/carousel';
import { NextToMeData } from '../../../data/modules/catalog-items-data/models/catalog-item.service';
import { ChangeCatalogFilter } from '../../../data/modules/catalog-data/store/catalog-table.actions';
import { CatalogFilter } from '../../../data/modules/catalog-data/models/catalog.service';

@Component({
  selector: 'app-carousel-card',
  templateUrl: './carousel-card.component.html',
  styleUrls: ['./carousel-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@TakeUntilDestroy
export class CarouselCardComponent {
  private _carouselData: CarouselData;
  public componentDestroy: () => Subject<any>;
  public icons = CustomIcons;
  @Input() public textColorClass = 'primary-color-60';
  @Select(MainPageState.getChosenCatalogOnMap) public chosenCatalogId$: Observable<number>;
  @Input() public proportion = 13;
  @Input() public criteria: CatalogFilter | null;
  @Input() public criteriaLink: string;
  @Input() public hasShowDownloads: boolean;
  @Input() public isFloating: boolean;
  public get carouselData(): CarouselData {
    return this._carouselData;
  }
  @Input() public set carouselData(value: CarouselData) {
    if (value && value !== this._carouselData) {
      this._carouselData = cloneDeep(value);
      this.checkFirstItem();
    }
  }

  @Input() public clickable = false;
  @Output() public readonly cardClick = new EventEmitter<void>();

  public chosenCardId: number;

  public nextSlide = 1;

  constructor(
    private cdr: ChangeDetectorRef,
    private store: Store,
    private mainPageService: MainPageService,
    private router: Router,
    private activeRouter: ActivatedRoute,
    private location: Location
  ) {}

  private checkFirstItem() {
    if (this._carouselData && this._carouselData?.data && this._carouselData?.data?.length > 0) {
      const recomendationId = this.activeRouter.snapshot?.queryParams?.recommendations;
      const catalogGlobalId = this.activeRouter.snapshot?.queryParams?.catalogGlobalId;
      const firstItemId: number = recomendationId ?? catalogGlobalId ?? this._carouselData.data[0][0]?.catalogId;

      let datasetId = 0;

      for (let i = 0; this._carouselData.data.length > i; i++) {
        datasetId = this._carouselData.data[i].find(x => x.id === firstItemId)?.datasetId ?? 0;
        if (datasetId > 0) {
          break;
        }
      }
      this.choseCard(+firstItemId, datasetId, false);
    }
  }

  public check(currenSlide: number): void {
    this.nextSlide = currenSlide + 1;
    this.cdr.markForCheck();
  }

  public choseCard(id: number, datasetId: number, isCardClick = true): void {
    let isRecommendation = false;
    if (this.mainPageService.isRecommendationId) {
      isRecommendation = true;
      this.mainPageService.isRecommendationId = id;

      setLocationQueryParams(
        {
          recommendations: id
        },
        this.router,
        this.location
      );
    }

    const nextToMyData: NextToMeData = this.mainPageService.isNextMeData ?? {
      isNextMeData: false
    };
    if (isCardClick) {
      this.cardClick.emit();
    }

    if (this.clickable) {
      if (isRecommendation) {
        this.store
          .dispatch(new GetRecommendationCatalogItemsForUser(id))
          .pipe(takeUntil(this.componentDestroy()))
          .subscribe(() => {
            this.store.dispatch(new GetCatalogGeoData(nextToMyData, true, '', id, datasetId));
          });
      } else {
        this.store.dispatch(new GetCatalogGeoData(nextToMyData, isRecommendation, '', id, datasetId));
      }
      this.chosenCardId = id;

      this.store.dispatch([new GetSelectCatalog(id), new GetCatalogInfo(id), new SetChosenCatalogOnMap(id)]);
    } else {
      this.store.dispatch(
        new SetSelectCatalog({
          id: id,
          datasetId: datasetId
        })
      );
    }
  }

  public setFilter(): void {
    if (this.criteria) {
      this.store.dispatch(new ChangeCatalogFilter(this.criteria, false, true));
    }
  }
}
